import { ptsToInch } from "../../helpers";
import { TextItem } from "../../types";

/* eslint id-length: 0 */
export const defaultCompanyName = "EY";

export const eyYellow = "ffe600";
export const eyBlack = "2e2e38";
export const eyWhite = "f6f6fa";
export const eyGray2 = "c4c4cd";

export const leftOffset = ptsToInch(0);
export const topOffset = ptsToInch(0);
export const fullHeight = ptsToInch(540);
export const fullWidth = ptsToInch(720);
export const spaceSize = ptsToInch(5);

export const sidebarWidth = ptsToInch(160);
export const imageSize = ptsToInch(113);
export const customImagePosition = {
  x: fullWidth - ptsToInch(37) - (3 / 2) * spaceSize,
  y: fullHeight - ptsToInch(36) - spaceSize / 2,
  w: ptsToInch(35),
  h: ptsToInch(35)
};
export const defaultImagePosition = {
  x: fullWidth - ptsToInch(100) - 2 * spaceSize,
  y: fullHeight - ptsToInch(30),
  w: ptsToInch(100),
  h: ptsToInch(30)
};
export const imageMargin = (sidebarWidth - imageSize) / 2;

export const EMPTY_LINE: TextItem = {
  text: "_",
  options: {
    transparency: 100,
    //actual height of space
    fontSize: 3,
    lineSpacing: 5,
    breakLine: true
  }
};
export const CHARS_PER_POINT = 0.26;
